"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _filesize = _interopRequireDefault(require("filesize"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default(Froala) {
  Froala.PLUGINS.mediaSizeHintPlugin = function (editor) {
    var insertHintIfNeeded = function insertHintIfNeeded(type, maxSizeInBytes) {
      var popup = editor.popups.get("".concat(type, ".insert"));
      if (popup.find('.max-size-hint').length > 0) return;
      var form = popup.find(".fr-".concat(type, "-upload-layer .fr-form"));
      var div = document.createElement('div');
      div.className = 'max-size-hint';
      div.innerText = "Upload limit: ".concat((0, _filesize.default)(maxSizeInBytes), " max");
      form.parent().get(0).insertBefore(div, form.get(0));
    };

    var _init = function _init() {
      editor.events.on('popups.show.image.insert', function () {
        insertHintIfNeeded('image', editor.opts.imageMaxSize);
      });
      editor.events.on('popups.show.video.insert', function () {
        insertHintIfNeeded('video', editor.opts.videoMaxSize);
      });
      editor.events.on('popups.show.file.insert', function () {
        insertHintIfNeeded('file', editor.opts.fileMaxSize);
      });
    };

    return {
      _init: _init
    };
  };
};

exports.default = _default;